import {
  Stack,
  Card,
  Button,
  OverlayTrigger,
  Tooltip,
  Modal,
} from "react-bootstrap";
import { TbClockCancel } from "react-icons/tb";
import { formatRut } from "../../validations/format";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import Flag from "./Flag";
import Motivo from "./Motivo";

const styles = {
  card: (hasPersona) => ({
    padding: "1rem",
    flex: 1,
    minHeight: "180px",
    backgroundColor: hasPersona ? undefined : "var(--color-gray)",
  }),
  textMuted: { color: "#6c757d" },
  button: {
    backgroundColor: "var(--color-red)",
    color: "var(--color-text)",
    border: "none",
    boxShadow: "none",
    outline: "none",
    marginLeft: "0.25rem",
  },
};

function AtencionActual({ actual, onFinalizar, onDescartar }) {
  const hasPersona = actual && actual.solicitante;
  const navigate = useNavigate();
  const [showDescartarModal, setShowDescartarModal] = useState(false);
  const [showFinalizarModal, setShowFinalizarModal] = useState(false);

  const displayRut = actual.solicitante
    ? actual.solicitante.pasaporte
      ? actual.solicitante.rut
      : formatRut(actual.solicitante.rut)
    : "";

  const handleVerFicha = () => {
    navigate("/atencion/ficha", {
      state: { idActual: actual.solicitante.idS },
    });
  };

  const handleDescartarClick = () => {
    setShowDescartarModal(true);
  };

  const confirmDescartar = () => {
    setShowDescartarModal(false);
    if (onDescartar) {
      onDescartar();
    }
  };

  const cancelDescartar = () => {
    setShowDescartarModal(false);
  };

  const handleFinalizarClick = () => {
    setShowFinalizarModal(true);
  };

  const confirmFinalizar = () => {
    setShowFinalizarModal(false);
    if (onFinalizar) {
      onFinalizar();
    }
  };

  const cancelFinalizar = () => {
    setShowFinalizarModal(false);
  };

  return (
    <Card style={styles.card(hasPersona)} className="h-100">
      <p className="mb-2 h5">Atención actual</p>
      {hasPersona ? (
        <Stack gap={2}>
          <Stack direction="horizontal" gap={1} className="align-items-left">
            <Flag
              key={actual.solicitante.flag} // Forzar re-render al cambiar flag desde el GET externo
              idSolicitante={actual.solicitante.idS}
              initialFlag={actual.solicitante.flag}
              size={25}
            />
            <strong>{actual.solicitante.nombre}</strong>
          </Stack>
          {actual.numeroTicket && (
          <p className="mb-0">
            <strong>Número:</strong> {actual.numeroTicket}
          </p>)}
          <p className="mb-3">
            <strong>{displayRut}</strong> - {actual.motivo}
          </p>
          <Stack direction="horizontal" gap={2} className="btn-stack">
            <Button className="btn-primary-blue me-auto" onClick={handleVerFicha}>
              Ver ficha
            </Button>

            <OverlayTrigger
              placement="top"
              trigger={["hover"]}
              delay={{ show: 1000, hide: 0 }}
              overlay={
                <Tooltip className="tooltip-ficha">Usuario no apareció</Tooltip>
              }
            >
              <Button
                variant="secondary"
                onClick={handleDescartarClick}
              >
                <TbClockCancel className="me-1" /> Descartar
              </Button>
            </OverlayTrigger>

            <Button
              variant="danger"
              onClick={handleFinalizarClick}
            >
              Finalizar
            </Button>
          </Stack>
        </Stack>
      ) : (
        <p style={styles.textMuted}>
          Ninguna atención en curso en este momento
        </p>
      )}

      {/* Modal de confirmación para descartar */}
      <Modal show={showDescartarModal} onHide={cancelDescartar} centered>
        <Modal.Header closeButton>
          <Modal.Title>Confirmar Descarte</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          ¿Está seguro que desea descartar esta atención? Esta acción no se
          puede deshacer.
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={cancelDescartar}>
            Cancelar
          </Button>
          <Button variant="danger" onClick={confirmDescartar}>
            Descartar
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal de confirmación para finalizar */}
      <Modal show={showFinalizarModal} onHide={cancelFinalizar} centered>
        <Modal.Header closeButton>
          <Modal.Title>Confirmar Finalizar Atención</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          ¿Está seguro que desea finalizar esta atención? No podrá revertir esta
          acción.
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={cancelFinalizar}>
            Cancelar
          </Button>
          <Button variant="danger" onClick={confirmFinalizar}>
            Finalizar
          </Button>
        </Modal.Footer>
      </Modal>
    </Card>
  );
}

export default AtencionActual;
